import _regeneratorRuntime from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

/**
 * @typedef Slice
 * @property {number} offset
 * @property {number} length
 */
export var BaseSource =
/*#__PURE__*/
function () {
  function BaseSource() {
    _classCallCheck(this, BaseSource);
  }

  _createClass(BaseSource, [{
    key: "fetch",

    /**
     *
     * @param {Slice[]} slices
     * @returns {ArrayBuffer[]}
     */
    value: function () {
      var _fetch = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(slices) {
        var _this = this;

        var signal,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                signal = _args.length > 1 && _args[1] !== undefined ? _args[1] : undefined;
                return _context.abrupt("return", Promise.all(slices.map(function (slice) {
                  return _this.fetchSlice(slice, signal);
                })));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
    /**
     *
     * @param {Slice} slice
     * @returns {ArrayBuffer}
     */

  }, {
    key: "fetchSlice",
    value: function () {
      var _fetchSlice = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(slice) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throw new Error("fetching of slice ".concat(slice, " not possible, not implemented"));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function fetchSlice(_x2) {
        return _fetchSlice.apply(this, arguments);
      }

      return fetchSlice;
    }()
    /**
     * Returns the filesize if already determined and null otherwise
     */

  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "fileSize",
    get: function get() {
      return null;
    }
  }]);

  return BaseSource;
}();